import ArtGallery from "./art/index";

export default function InProgressArtList() {
  return <ArtGallery type="in-progress" />;
}
